import { render, staticRenderFns } from "./NavbarSidebarContainer.vue?vue&type=template&id=665e656c&"
import script from "./NavbarSidebarContainer.vue?vue&type=script&lang=js&"
export * from "./NavbarSidebarContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports